import { render, staticRenderFns } from "./DislikeIcon.vue?vue&type=template&id=541f65ed&scoped=true&"
import script from "./DislikeIcon.vue?vue&type=script&lang=js&"
export * from "./DislikeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f65ed",
  null
  
)

export default component.exports